// extracted by mini-css-extract-plugin
export default {"dashboard-card":"dashboardCardStyles_dashboard-card__jFDKU","count":"dashboardCardStyles_count__g-S3L"};